import { ChakraProvider } from '@chakra-ui/react';
import CandidateInterviewHeader from '@/components/CandidateInterviewHeader';
import InterviewEnding from '@/components/InterviewEnding';
import SendConfirmationModal from '@/components/SendConfirmationModal';
import TechnicalValidationWelcoming from '@/components/TechnicalValidationWelcoming';
import WelcomingInterviewContainer from '@/components/WelcomingInterviewContainer';
import { chakraExtendedTheme } from '@/styles/theme';
import { CandidateInterviewPageStages } from '@/types';
import { InterviewTypes } from '@/utils/interviews';
import SubmittingTechnicalValidation, { ProjectType } from '../SubmittingTechnicalValidation';

type CandidateTechnicalValidationInterviewType = {
  isSubmitting?: boolean;
  interviewState: CandidateInterviewPageStages;
  interviewDescription?: string;
  interviewName?: string;
  alertState: boolean;
  candidateName: string;
  onSubmitProject: (data: ProjectType) => void;
  onConfirmSubmitting: () => void;
  onCancelSubmitting: () => void;
  onChangeInterviewState: (state: CandidateInterviewPageStages) => void;
};

export default function CandidateTechnicalValidationInterviewComponent({
  candidateName,
  interviewDescription,
  interviewName,
  isSubmitting,
  onChangeInterviewState,
  onSubmitProject,
  interviewState,
  alertState,
  onConfirmSubmitting,
  onCancelSubmitting,
}: CandidateTechnicalValidationInterviewType): JSX.Element {
  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <div id="dialog-container" />
      <div>
        <CandidateInterviewHeader
          candidateName={candidateName}
          interviewType={InterviewTypes.TECHNICAL_CHALLENGE}
          interviewState={interviewState}
        />

        {interviewState === CandidateInterviewPageStages.WELCOME && (
          <WelcomingInterviewContainer
            firstName={candidateName.split(' ')[0]}
            interviewType={InterviewTypes.TECHNICAL_CHALLENGE}
            onClickNextStep={() => onChangeInterviewState(CandidateInterviewPageStages.SUBMIT)}
          >
            <TechnicalValidationWelcoming description={interviewDescription} name={interviewName} />
          </WelcomingInterviewContainer>
        )}

        {interviewState === CandidateInterviewPageStages.SUBMIT && (
          <SubmittingTechnicalValidation
            onChangeInterviewState={onChangeInterviewState}
            onSubmitProject={onSubmitProject}
          />
        )}

        {interviewState === CandidateInterviewPageStages.ENDING && (
          <InterviewEnding interviewType={InterviewTypes.TECHNICAL_CHALLENGE} />
        )}

        <SendConfirmationModal
          isButtonDisabled={isSubmitting}
          isOpen={alertState}
          actionMessage="your project to Technical Challenge will be sent to Trio. Make
              sure you’re all set before sending it."
          onClose={onCancelSubmitting}
          onConfirmHandler={onConfirmSubmitting}
        />
      </div>
    </ChakraProvider>
  );
}
